import React, { useEffect, useState, Fragment, useRef } from 'react';
import { Link } from 'react-router-dom';
import axios from '../../api/axios';
import Skeleton from '@material-ui/lab/Skeleton';
import Badge from '@material-ui/core/Badge';
import Avatar from '@material-ui/core/Avatar';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import moment from 'moment-jalaali';
import Divider from '@material-ui/core/Divider';
import formatNumber from '../../fns/formatNumber';
import { useHistory } from 'react-router-dom';

const OnlineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: '#44b700',
    color: '#44b700',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      animation: '$ripple 1.2s infinite ease-in-out',
      border: '1px solid currentColor',
      content: '""',
    },
  },
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}))(Badge);
const OfflineBadge = withStyles((theme) => ({
  badge: {
    backgroundColor: 'gray',
    color: 'gray',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    '&::after': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      border: '1px solid currentColor',
      content: '""',
    },
  },
}))(Badge);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    cursor: 'pointer',
  },
  avatar: ({ height, width }) => ({
    width,
    height,
  }),
  userName: { marginLeft: theme.spacing(0.5) },
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(1),
    width: 250,
  },
}));

const User = ({
  user,
  fullName = false,
  justAvatar = false,
  height = 30,
  width = 30,
  onClick,
}) => {
  const classes = useStyles({ height, width });
  const [person, setPerson] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [userInfo, setUserInfo] = useState(null);
  const timeout = useRef();
  const history = useHistory();

  const handlePopoverOpen = (event) => {
    timeout.current = setTimeout(function () {
      setAnchorEl(event.target);
      getUserInfo(person._id);
    }, 1000);
  };
  const handlePopoverClose = () => {
    clearTimeout(timeout.current);
    setAnchorEl(null);
  };
  const getUserInfo = async (userId) => {
    try {
      const { data } = await axios.get(
        `/api/v1/admin/users/${userId}/moreInfo`
      );
      data?.ok && setUserInfo(data);
    } catch (error) {}
  };
  const handleClick = () => {
    onClick && onClick(person);
    !onClick &&
      history.push(
        `/protected/admin/users/${
          person.role[0] ? person.role[0] : 'customer'
        }/${person._id}`
      );
  };

  useEffect(() => {
    if (typeof user === 'object') {
      setPerson(user);
    } else {
      (async () => {
        try {
          const { data } = await axios.get(`/api/v1/admin/user/${user}`);
          setPerson(data);
        } catch (error) {
          console.error(error);
        }
      })();
    }
  }, []);

  return (
    <Fragment>
      {person === null ? (
        <Skeleton variant="circle" width={width} height={height} />
      ) : (
        <div
          onClick={handleClick}
          className={classes.root}
          onMouseEnter={handlePopoverOpen}
          onMouseLeave={handlePopoverClose}
        >
          {person.online ? (
            <OnlineBadge
              overlap="circular"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              variant="dot"
            >
              <Avatar className={classes.avatar}>
                <PersonIcon />
              </Avatar>
            </OnlineBadge>
          ) : (
            <OfflineBadge
              overlap="circular"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              variant="dot"
            >
              <Avatar className={classes.avatar}>
                <PersonIcon />
              </Avatar>
            </OfflineBadge>
          )}

          {justAvatar ? null : (
            <div className={classes.userName}>
              {person.legal
                ? person.company
                  ? person.company || ''
                  : `${person.firstName || ''} ${person.lastName || ''}`
                : fullName
                ? `${person.firstName || ''} ${person.lastName || ''}`
                : person.lastName}
            </div>
          )}
        </div>
      )}
      <Popover
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {!userInfo && (
          <div>
            <Skeleton variant="text" animation="wave" />
            <Skeleton variant="text" animation="wave" />
            <Skeleton variant="text" animation="wave" />
            <Skeleton variant="text" animation="wave" />
          </div>
        )}
        {userInfo && userInfo?.driver && (
          <div>
            <div className="interests">
              <b>علاقه‌مندی‌ها: </b>
              {userInfo?.interests?.[0]
                ? moment(userInfo.interests[0].createdAt).format(
                    'jMM/jDD hh:mm'
                  )
                : ''}
            </div>
            {userInfo?.interests?.length ? (
              <div>
                <ul>
                  {userInfo.interests?.[0]?.states?.map((state) => (
                    <li key={state._id}>{state.title}</li>
                  ))}
                </ul>
              </div>
            ) : (
              <div>تابحال مسیری انتخاب نکرده است.</div>
            )}
            <Divider />
            <div>
              <b>آخرین ورود: </b>

              {`${
                userInfo?.session?.[0]?.updatedAt
                  ? moment(userInfo.session[0].updatedAt).format(
                      'jMM/jDD hh:mm'
                    )
                  : 'تاکنون ورودی ثبت نشده است'
              }`}
            </div>
            <div>
              <b>موجودی کیف‌پول: </b>
              {userInfo?.credit > 0
                ? formatNumber(userInfo.credit) + ' تومان'
                : 0}
            </div>
          </div>
        )}
        {userInfo?.isAdmin && (
          <div>
            <ul>
              <li>
                <b>تعداد سفارشات:</b>
                {userInfo?.countCurrentOrders}
              </li>
              <li>
                <b>پورسانت سفارشات:</b>
                {formatNumber(userInfo?.income)}
              </li>
            </ul>
          </div>
        )}
      </Popover>
    </Fragment>
  );
};

export default React.memo(User);
